import React from "react";

const FormContainer = ({ children, grid = 3 }) => {
  return (
    <div className="container mx-auto py-6">
      <div
        // className={`grid grid-cols-1 gap-6 md:grid-cols-3 lg:grid-cols-3 gap-x-6 gap-y-6 + ${className}`}
        // className={`grid grid-cols-1 gap-6 md:grid-cols-${grid} lg:grid-cols-3 gap-x-6 gap-y-6`}
        className={`grid grid-cols-1 gap-6 md:grid-cols-${grid} lg:grid-cols-${grid} gap-x-6 gap-y-6`}
      >
        {children}
      </div>
    </div>
  );
};

export default FormContainer;
